import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { show as showModal } from 'redux-modal';
import moment from 'moment';
import classnames from 'classnames';

import { Element } from 'react-scroll';
import { Collapse } from 'reactstrap';
import MediaQuery from 'react-responsive';

import ProfileSection from 'ui/users/profile-section';

import Button from 'ui/common/button';
import Icon from 'ui/common/rebranding/components/Icon';
import CompanyLogo from 'ui/companies/logo';
import { MODAL_NAME as ADD_ENTRY_MODAL_NAME } from 'ui/work-experience/new';
import LinkedInImportButton from 'ui/users/linkedin-import';
import themeConfig from 'ui/theme/config';
import UpdateWorkExperienceEntryModal, {
  MODAL_NAME as UPDATE_ENTRY_MODAL_NAME,
} from 'ui/work-experience/update';

const messages = defineMessages({
  title: {
    id: 'update-profile.work-experience.title',
    defaultMessage: 'Work Experience',
  },
  addButton: {
    id: 'update-profile.work-experience.add-button.title',
    defaultMessage: 'Add work experience',
  },
  entryTitle: {
    id: 'update-profile.work-experience.entry-title',
    defaultMessage: '{position} at {companyName}',
  },
  entryTitleWithoutPosition: {
    id: 'update-profile.work-experience.entry-title-without-position',
    defaultMessage: '{companyName}',
  },
  currentlyWorkingEndDate: {
    id: 'update-profile.work-experience.currentlyWorkingEndDate',
    defaultMessage: 'Present',
  },
});

class WorkExperienceSection extends Component {
  constructor(props) {
    super(props);

    autoBind(this);

    this.state = {
      isOpen: true,
    };
  }

  showAddEntryModal() {
    this.props.showModal(ADD_ENTRY_MODAL_NAME);
  }

  showUpdateEntryModal(id) {
    this.props.showModal(UPDATE_ENTRY_MODAL_NAME(id));
  }

  renderEmpty() {
    return null;
  }

  renderEntry(entry, index) {
    const { canManage, intl: { locale, formatMessage } } = this.props;
    const localeData = moment.localeData(locale);
    const monthNames = localeData.monthsShort();

    const horizontalPaddingClassName = index % 2 === 0 ? 'pr-md-5' : 'pl-md-5';

    const { company } = entry;
    return (
      <Element
        key={entry.id}
        name={`work-experience-entry-${entry.id}`}
        className={classnames('col-12 col-md-6 pb-4', horizontalPaddingClassName)}
      >
        <div className="border-bottom pb-3 h-100">
          <header className="d-flex justify-content-between align-items-start">
            <div>
              <header className="mb-0 pr-3 text-break-word">
                <h3 className="mb-1">{entry.title}</h3>
                {company &&
                  company.companyName && (
                    <h3>
                      {entry.position
                        ? formatMessage(messages.entryTitle, {
                            position: entry.position,
                          })
                        : formatMessage(messages.entryTitleWithoutPosition, {
                            companyName: company.companyName,
                          })}
                    </h3>
                  )}
              </header>
              {((entry.startDate && entry.startDate.year && entry.startDate.month) ||
                (entry.currentlyWorking ||
                  (entry.endDate && entry.endDate.year && entry.endDate.month))) && (
                <p className="gray pb-1">
                  {[
                    entry.startDate &&
                      `${monthNames[entry.startDate.month - 1]} ${entry.startDate.year}`,
                    entry.currentlyWorking
                      ? formatMessage(messages.currentlyWorkingEndDate)
                      : entry.endDate &&
                        `${monthNames[entry.endDate.month - 1]} ${entry.endDate.year}`,
                  ]
                    .filter(val => val)
                    .join(' - ')}
                </p>
              )}
              {entry.location && <div className="text-muted pb-1">{entry.location}</div>}
            </div>

            <CompanyLogo company={company} size={64} textSizeRatio={5} />
          </header>

          {entry.description && (
            <p className="text-break-word text-whitespace-pre-wrap py-3">{entry.description}</p>
          )}

          <div className="d-flex pt-3 justify-content-end">
            {canManage && (
              <span>
                <Icon
                  name="icon--edit"
                  background
                  onClick={() => this.showUpdateEntryModal(entry.id)}
                />
                <UpdateWorkExperienceEntryModal id={entry.id} />
              </span>
            )}
          </div>
        </div>
      </Element>
    );
  }

  handleDelete() {}

  handleAddition() {}

  render() {
    const { canManage, entries, intl: { formatMessage } } = this.props;
    if (!canManage && (!entries || entries.length === 0)) return null;

    return (
      <div className={classnames('row align-items-center py-4')} id="workExperience">
        <ProfileSection
          title={formatMessage(messages.title)}
          collapsible
          className="col-12"
          canManage={canManage}
          buttonNextToToggle={
            <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.md}>
              <LinkedInImportButton className="d-inline" isReady={false} />
            </MediaQuery>
          }
          actions={[
            canManage && (
              <Button
                key="add"
                isReady={false}
                onClick={() => this.showAddEntryModal()}
                className="m-0"
              >
                {formatMessage(messages.addButton)}
              </Button>
            ),
          ].filter(Boolean)}
        >
          <Collapse isOpen={this.state.isOpen} className="row pt-4">
            {entries && entries.length > 0
              ? entries
                  .slice(0)
                  .reverse()
                  .map(this.renderEntry)
              : this.renderEmpty()}
          </Collapse>
        </ProfileSection>
      </div>
    );
  }
}

const mapDispatchToProps = {
  showModal,
};

export default connect(null, mapDispatchToProps)(injectIntl(WorkExperienceSection));
